module.exports = __webpack_public_path__ + "statics/img/FullChain-1@2x.50419665.png";